// mixins/scrollWithArrowsMixin.js
export default {
  data: function data() {
    return {
      scrollPairs: []
    };
  },
  methods: {
    setupScrollWithArrows: function setupScrollWithArrows() {
      var _this = this;
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.v-data-table__wrapper';
      var tables = document.querySelectorAll(selector);
      console.log('tables', tables);
      tables.forEach(function (table, index) {
        var wrapper = document.createElement('div');
        wrapper.className = 'scroll-arrow-wrapper';
        var leftArrow = document.createElement('button');
        leftArrow.className = 'scroll-arrow left-arrow';
        leftArrow.innerHTML = '⬅️';
        var rightArrow = document.createElement('button');
        rightArrow.className = 'scroll-arrow right-arrow';
        rightArrow.innerHTML = '➡️';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(leftArrow);
        wrapper.appendChild(table);
        wrapper.appendChild(rightArrow);
        _this.setupScrollEvents(table, leftArrow, rightArrow);
      });
    },
    setupScrollEvents: function setupScrollEvents(table, leftArrow, rightArrow) {
      var checkScrollAvailability = function checkScrollAvailability() {
        var maxScrollLeft = table.scrollWidth - table.clientWidth;
        leftArrow.style.display = table.scrollLeft > 0 ? 'block' : 'none';
        rightArrow.style.display = table.scrollLeft < maxScrollLeft ? 'block' : 'none';
      };
      leftArrow.addEventListener('click', function () {
        table.scrollLeft -= 200;
      });
      rightArrow.addEventListener('click', function () {
        table.scrollLeft += 200;
      });
      table.addEventListener('scroll', checkScrollAvailability);
      window.addEventListener('resize', checkScrollAvailability);
      checkScrollAvailability();
      this.scrollPairs.push({
        table: table,
        leftArrow: leftArrow,
        rightArrow: rightArrow
      });
    },
    teardownScrollWithArrows: function teardownScrollWithArrows() {
      this.scrollPairs.forEach(function (_ref) {
        var table = _ref.table,
          leftArrow = _ref.leftArrow,
          rightArrow = _ref.rightArrow;
        leftArrow.removeEventListener('click', function () {});
        rightArrow.removeEventListener('click', function () {});
        table.removeEventListener('scroll', function () {});
        window.removeEventListener('resize', function () {});
      });
      this.scrollPairs = [];
    }
  }
};